import { useAppTabs } from "~stores/useAppTabs.ts";
import { getCurrentInstance, watch, onScopeDispose } from "vue";

window.ontabclose = {};

export interface CloseTabEvent {
	prevent: boolean;
}

export const onActivateTab = (callback: (fullPath: string | null) => unknown) => {
	const node = getCurrentInstance()?.vnode;
	callback(node?.props?.tab?.fullPath);
};

export const onCloseTab = (callback: (event: CloseTabEvent) => unknown) => {
	const node = getCurrentInstance()?.vnode;

	if (node == null) return;
	if (node.props == null) return;
	if (!("tab" in node.props)) {
		console.error("onCloseTab failed because component did not receive 'tab' prop!!");
		return;
	}

	const fullPath = node.props.tab.fullPath;
	window.ontabclose[fullPath] = callback;

	// The callback closes over the whole component scope, and `window.ontabclose` is a global object:
	// only WindowTabBar's close button deletes the entry again, so closing a tab any other way
	// (Ctrl+W, FormPage closing itself after saving) left the entry — and with it the component and
	// everything it referenced — permanently reachable. Dropping it when the scope is disposed keeps
	// the map free of dead components regardless of how the tab was closed.
	onScopeDispose(() => {
		if (window.ontabclose[fullPath] === callback) {
			delete window.ontabclose[fullPath];
		}
	});
};

type Notification = {
	type: "SUCCESS" | "WARNING" | "ERROR" | "INFO";
	title: string;
	message: string | null;
};
export function onNotification(callback: (notification: Notification) => void) {
	const onNotif = (event: Event) => {
		if (!(event instanceof CustomEvent)) return;

		const notification = event.detail as Notification;

		callback(notification);
	};
	window.addEventListener("food:notification", onNotif);

	return () => {
		window.removeEventListener("food:notification", onNotif);
	};
}
